import type { GifItem, StickerItem } from '../types';

/**
 * Sticker packs are emoji-composed rather than image assets, so the picker
 * costs zero network requests and zero bytes of image payload.
 */
export const STICKERS: readonly StickerItem[] = [
  { id: 'ship-it', emoji: '🚢', label: 'Ship it', pack: 'Work' },
  { id: 'lgtm', emoji: '✅', label: 'LGTM', pack: 'Work' },
  { id: 'blocked', emoji: '🚧', label: 'Blocked', pack: 'Work' },
  { id: 'on-it', emoji: '🫡', label: 'On it', pack: 'Work' },
  { id: 'brb', emoji: '🏃', label: 'BRB', pack: 'Work' },
  { id: 'deploying', emoji: '📦', label: 'Deploying', pack: 'Work' },
  { id: 'celebrate', emoji: '🎉', label: 'Celebrate', pack: 'Mood' },
  { id: 'facepalm', emoji: '🤦', label: 'Facepalm', pack: 'Mood' },
  { id: 'mind-blown', emoji: '🤯', label: 'Mind blown', pack: 'Mood' },
  { id: 'coffee', emoji: '☕', label: 'Coffee first', pack: 'Mood' },
  { id: 'fire', emoji: '🔥', label: 'On fire', pack: 'Mood' },
  { id: 'sleepy', emoji: '😴', label: 'Sleepy', pack: 'Mood' },
];

function tile(id: string, title: string, hueA: string, hueB: string): GifItem {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="180"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${hueA}"/><stop offset="1" stop-color="${hueB}"/></linearGradient></defs><rect width="240" height="180" fill="url(#g)"/><text x="50%" y="52%" fill="#fff" font-family="Inter,sans-serif" font-size="20" text-anchor="middle">${title}</text></svg>`;
  const url = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  return { id, url, previewUrl: url, width: 240, height: 180, title };
}

/**
 * STUB: a local catalogue. A real deployment swaps this for a proxied GIF
 * provider behind the API so no third-party script or key reaches the client.
 */
export const GIF_CATALOGUE: readonly GifItem[] = [
  tile('celebrate', 'Celebrate', '#6D28D9', '#2563EB'),
  tile('applause', 'Applause', '#DB2777', '#7C3AED'),
  tile('thumbs-up', 'Thumbs up', '#0D9488', '#2563EB'),
  tile('shipping', 'Shipping it', '#EA580C', '#DB2777'),
  tile('mind-blown', 'Mind blown', '#4F46E5', '#0891B2'),
  tile('facepalm', 'Facepalm', '#475569', '#0F766E'),
  tile('typing', 'Typing…', '#16A34A', '#0D9488'),
  tile('deploy', 'Deploying', '#7C3AED', '#DB2777'),
];

export function searchGifs(query: string): readonly GifItem[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return GIF_CATALOGUE;
  return GIF_CATALOGUE.filter((gif) => gif.title.toLowerCase().includes(needle));
}
